import client from '../../services/session/apiClient';

export default {
  getChatterUploads: (params = {}) => {
    return client.get('/chatter/publishing/uploads', { params }).then(response => response.data.results);
  },
  deleteChatterUpload: (id) => {
    return client.delete(`/chatter/publishing/upload/${id}`);
  },
  saveChatterUpload: (accountId, formData, progressCallback) => {
    return client.post(`/chatter/publishing/upload/${accountId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: progressCallback
    }).then(response => response.data);
  }
}
